import { _throwNotImplementedException } from './COM';

/**
 * Abstract Rs232Reply, represents a reply packet from the display
 * @class
 * @param {number[]} bytes - the bytes received from the display
 */
function Rs232Reply(bytes) {
    this.rawPacket = bytes;

    try {
        this.packetString = bytes
            .map(function (byte) {
                return String.fromCharCode(byte);
            })
            .join('');
    } catch (asdfsadf) {
        this.packetString = '';
    }
}

/**
 * verifies the integrity of the data packet received from the display
 * @method
 * @abstract
 * @throws will throw error if not overridden in implementing class
 */
Rs232Reply.prototype.verifyPacket = _throwNotImplementedException('Rs232Reply.verifyPacket');

/**
 * converts the reply to a human-readable string representation
 * @method
 * @abstract
 * @throws will throw error if not overridden in implementing class
 */
Rs232Reply.prototype.toString = _throwNotImplementedException('Rs232Reply.toString');

export { Rs232Reply };
